// Tracks active /api/ fetch requests and emits events so Loading.jsx
// can wait for initial page data before hiding the spinner.

const listeners = new Set();
let activeCount = 0;

function notify() {
  listeners.forEach(fn => fn(activeCount));
}

export const fetchTracker = {
  subscribe(fn) {
    listeners.add(fn);
    return () => listeners.delete(fn);
  },

  getCount() {
    return activeCount;
  },

  // Call once at app startup to patch window.fetch
  install() {
    if (window.__fetchTrackerInstalled) return;
    window.__fetchTrackerInstalled = true;

    const original = window.fetch;
    window.fetch = async (...args) => {
      const url = typeof args[0] === 'string' ? args[0] : args[0]?.url ?? '';
      const isApiCall = url.startsWith('/api/');

      if (isApiCall) {
        activeCount++;
        notify();
      }

      try {
        return await original(...args);
      } finally {
        if (isApiCall) {
          activeCount--;
          notify();
        }
      }
    };
  },
};
